<template>
    <div>
        <span class="dz-label">{{label}}</span>
        <ckeditor  :value="value" v-on="$listeners" :config="editorConfig"></ckeditor>
    </div>
</template>

<script>
    import CKEditor from 'ckeditor4-vue';
    export default {
        name: "Editor",
        components: {
            // Use the <ckeditor> component in this view.
            ckeditor: CKEditor.component
        },
        props: {
            value: String,
            label: String
        },
        data() {
            return {
                editorConfig: {
                    toolbar: [['Format', '-', 'Bold', 'Italic', '-', 'Link', '-', 'BulletedList', 'NumberedList', '-', 'Undo', 'Redo']],
                }
            }
        },
    }
</script>

<style>
.cke_notification_warning {
    display: none;
}
</style>
